import { DateTime } from 'luxon';

export function calculateTimeDurationInMinutes(start: string, end: string) {
  const startDt = DateTime.fromISO(start);
  const endDt = DateTime.fromISO(end);
  return endDt.diff(startDt, 'minutes').minutes;
}
